import { format, subMonths, add } from 'date-fns'
import { toFixedCustom } from 'utils'
import { getCustomIntl } from 'config/config'

const intl = getCustomIntl()
const rangeSelectorButtonsContent = {
  ytd: intl.formatMessage({ id: 'fundDetail.tabs.performanceTab.YTD' }),
  '3m': intl.formatMessage({ id: 'fundDetail.tabs.performanceTab.monthsText' }, { monthsCount: 3 }),
  '6m': intl.formatMessage({ id: 'fundDetail.tabs.performanceTab.monthsText' }, { monthsCount: 6 }),
  '1y': intl.formatMessage({ id: 'fundDetail.tabs.performanceTab.yearsText' }, { yearsCount: 1 }),
  '2y': intl.formatMessage({ id: 'fundDetail.tabs.performanceTab.yearsText' }, { yearsCount: 2 }),
  '3y': intl.formatMessage({ id: 'fundDetail.tabs.performanceTab.yearsText' }, { yearsCount: 3 }),
  '5y': intl.formatMessage({ id: 'fundDetail.tabs.performanceTab.yearsText' }, { yearsCount: 5 }),
  '10y': intl.formatMessage({ id: 'fundDetail.tabs.performanceTab.yearsText' }, { yearsCount: 10 })
}

// const tooltipFormatter = (pointThis, htmlFormatter) => {
//   const formattedTooltipHtml = pointThis.points.map((point) => htmlFormatter(point))
//   return [``].concat(formattedTooltipHtml)
// }

const chartConfig = {
  scrollbar: {
    enabled: false
  },
  plotOptions: {
    // Calculate percentage automatically
    series: {
      compare: 'percent',
      compareStart: true
    }
  },
  legend: {
    x: 57
  },
  tooltip: {
    changeDecimals: 2,
    valueDecimals: 2,
    formatter() {
      const formattedHtml = `<div class="fil-fund-compare__chart-tooltip">
        <div class="fil-fund-compare__chart-tooltip-date">${format(this.points[0].x, 'yyyy/MM/dd')}</div>
        ${this.points
          .map(
            (point) =>
              `<div class="fil-fund-compare__chart-tooltip-item"><span style="background-color: ${
                point.color
              }"></span><span>${toFixedCustom(point.point.change, 2)}%</span></div>`
          )
          .join('')}
      </div>`
      return formattedHtml
    }
  },
  displayMinMax: false,
  startFromZero: true,
  navigator: {
    enabled: false
  },
  topOptions: {
    lang: {
      rangeSelectorZoom: ''
    }
  },
  credits: {
    enabled: false
  },
  rangeSelectorOptions: {
    rangeSelectorButtonsContent,
    selectedId: '1y',
    onClick: () => {}
  },
  xAxis: {
    labels: {
      formatter(xLabelFormatter) {
        const self = this
        if (format(add(subMonths(self.axis.max, 6), { days: 1 }), 'TT') > self.axis.min) {
          return format(xLabelFormatter.value, 'yyyy/MM')
        }
        return format(xLabelFormatter.value, 'MM/dd')
      }
    }
  },
  yAxis: {
    labels: {
      formatter(yLabelFormatter) {
        const isDecimalNumber = Math.abs(yLabelFormatter.value) > 0 && Math.abs(yLabelFormatter.value) < 1
        return `${parseFloat(yLabelFormatter.value).toFixed(isDecimalNumber ? 2 : 1)} %`
      }
    }
  }
}

export default chartConfig
